/*****************************

Acoordions function

******************************/

export function initAccordion(els) { // all accrodions with given class

  els.forEach( function(el) { // loop each accrodion

    const accordionBtns = el.querySelectorAll('button'); // store button toggle as const
    const accordionSubs = el.querySelectorAll('button + *');

    accordionBtns.forEach( (item) => { // loop each button and store each one as item var

      item.addEventListener('click', toggleAccordion); // on each item click run toggle function

    });

    function toggleAccordion( ) {

      let sub = this.nextElementSibling;
      let setClasses = !this.classList.contains('active');

      subMenuSetClass( accordionBtns, 'active', 'remove' );
      subMenuSetClass( accordionSubs, 'show', 'remove' );

      if( setClasses ) {
        sub.style.maxHeight = `${sub.scrollHeight}px`;
        this.classList.toggle('active');
        sub.classList.toggle('show');
      }

    }

    function subMenuSetClass(els, className, fnName) {
      for( let i = 0; i < els.length; i++ ) {
        els[i].classList[fnName](className);
        els[i].style.maxHeight = null;
      }
    }

  });


}
